import * as Sentry from '@sentry/browser';
import { commonSentryConfig } from './common-sentry-config';
import { persistJourneyBreadcrumb } from './journey-breadcrumbs';

Sentry.init({
  ...commonSentryConfig,
  tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE),
  tracePropagationTargets: ['www.starfish.local', 'starfish.com'],
  integrations: [Sentry.browserTracingIntegration()],
  // Persist each breadcrumb so the pre-checkout journey survives the full page
  // load into the ng-checkout SPA and can be replayed onto checkout errors.
  beforeBreadcrumb(breadcrumb) {
    persistJourneyBreadcrumb(breadcrumb);

    return breadcrumb;
  },
  ignoreErrors: [
    'BraintreeError: Cannot contact the gateway at this time.',
    /wisepops/i,
    'TypeError: Load failed (www.chatbase.co)',
  ],
  denyUrls: [
    'app.wonderchat.io',
    'bat.bing.com',
    'cdn.wisepops.com',
    'cdn.ywxi.net',
    'googleads.g.doubleclick.net',
    'tools.luckyorange.com',
    'wisepops.net',
    'www.trustedsite.com',
  ],
});
